<template>
    <div class="container" v-title="type == 1 ? '设置密码' : '修改密码'">
        <Navigation-bar></Navigation-bar>
        <div class="container_content">
            <Title :title="titleText.title" :subtitle="titleText.subtitle"></Title>
            <div id="changePassword" >
                <div class="step1" v-if="step == 1">
                    <div class="content">
                        <ul>
                            <li>
                                <div class="item-input">
                                    <input type="text" disabled :value="textEncryption(form.phone, 3, 4, '****')" style="background:#FAFAFA;color: #747576">
                                </div>
                            </li>
                            <li>
                                <div class="item-input">
                                    <input type="tel" pattern="\d*" :class="{'error' : form.codeHint}" v-model.trim="form.code" @blur="codeBlur()" maxlength="6" placeholder="请输入验证码">
                                    <span v-if="!form.codeDisabled" class="text-btn"  :class="UserType == 1?'s':'c'" @click="sendCode()">获取验证码</span>
                                    <span v-else class="text-btn" style="color: #1B1C1E;" v-text="countDownText"></span>
                                </div>
                                <p class="errorHint" v-text="form.codeHint"></p>
                            </li>
                        </ul>
                    </div>
                    <div class="operation">
                        <button @click="checkAccount()">下一步</button>
                    </div>
                </div>
                <div class="step2"  v-if="step == 2">
                    <div class="content">
                        <ul>
                            <li>
                                <p class="hint" v-text="form.passwordHint"></p>
                                <div class="item-input">
                                    <input :type="form.pText ? 'password' : 'text'" v-model.trim="form.password" @blur="passwordBlur()" placeholder="输入新密码">
                                    <span class="text-btn" @click="()=>{this.form.pText = !this.form.pText}" v-text="form.pText?'显示':'隐藏'"></span>
                                </div>
                            </li>
                            <li>
                                <div class="item-input">
                                    <input :type="form.vpText ? 'password' : 'text'" :class="{'error' : form.verifyPasswordHint}" v-model.trim="form.verifyPassword" @blur="verifyPasswordBlur()" placeholder="请再次输入">
                                    <span class="text-btn" @click="()=>{this.form.vpText = !this.form.vpText}" v-text="form.vpText?'显示':'隐藏'"></span>
                                </div>
                                <p class="errorHint" v-text="form.verifyPasswordHint"></p>
                            </li>
                        </ul>
                    </div>
                    <div class="operation">
                        <button @click="forResetPassword()">完成</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>
<script>
import { mapGetters } from 'vuex';
import {
    SendVerificationCodeForResetPassword,
    CheckVerificationCodeForResetPassword,
    ResetPassword
} from "@/api"
import {
    textEncryption
} from '@js';
export default {
    name:"ChangePassword",
    data(){
        return {
            type:0,
            step: 1,
            form:{
                phone:"",
                code:"",
                codeHint:"",
                codeDisabled:false,
                password:"",
                passwordHint:"",
                pText:true,
                verifyPassword:"",
                verifyPasswordHint:"",
                vpText:true,
            },
            VerificationSerialNumber:"",
            token:"",
            countDown: 0,
            timer: null
        }
    },
    created(){
        if(this.$route.query.type == 1){
            this.type = 1;
        }
        if(this.$store.state.UserInfo.MobileNumber){
            this.form.phone = this.$store.state.UserInfo.MobileNumber;
        }
    },
    beforeDestroy(){
        clearInterval(this.timer);
    },
    computed:{
        ...mapGetters(['UserType']),
        titleText:function(){
            if(this.step == 1){
                return {
                    title:"获取验证码",
                    subtitle:"请注意查收短信验证码"
                };
            }else{
                if(this.type == 1){
                    return {
                        title:"设置密码",
                        subtitle:"请设置您的账户密码"
                    };
                }else{
                    return {
                        title:"修改密码",
                        subtitle:"请修改您的账户密码"
                    };
                }
            }
        },
        countDownText:function(){
            return this.countDown ? this.countDown + "s" : "";
        }
    },
    watch:{
        "form.code":function(){
            this.form.codeHint = ""; 
            if(this.form.code.length > 6){
                this.form.codeHint = "验证码错误"; 
            }
        },
        "form.password":function(){
            this.form.passwordHint = "";
            if(this.form.password.length > 12){
                this.form.passwordHint = "请输入6-12位密码";
            }
        },
        "form.verifyPassword":function(){
            this.form.verifyPasswordHint = "";
            if(this.form.verifyPassword != this.form.password){
                this.form.verifyPasswordHint = "两次密码不一致";
            }
        }
    },
    methods:{
        textEncryption,
        codeBlur(){
            if(this.form.code.length != 6){
                this.form.codeHint = "验证码错误";
                return false;
            }
        },
        passwordBlur(){
            if(!(/^[0-9a-zA-Z]{6,12}$/gm.test(this.form.password))){
                this.form.passwordHint = "请输入6-12位数字和字母密码";
                return false;
            }
        },
        verifyPasswordBlur(){
            if(this.form.password != this.form.verifyPassword){
                this.form.verifyPasswordHint = "两次密码不一致";
                return false;
            }
        },
        sendCode(){
            SendVerificationCodeForResetPassword({
                MobileNumber: this.form.phone
            }).then(data=>{
                if(data.Code == 0){
                    this.VerificationSerialNumber = data.VerificationSerialNumber;
                    this.countDown = 60;
                    this.form.codeDisabled = true;
                    clearInterval(this.timer);
                    this.timer = setInterval(() => {
                        this.countDown--;
                        if(this.countDown <= 0){
                            this.form.codeDisabled = false;
                            clearInterval(this.timer);
                        }
                    }, 1000);
                }
            })
        },
        checkAccount(){
            if(this.codeBlur() == false){
                return ;
            }
            CheckVerificationCodeForResetPassword({
                MobileNumber: this.form.phone,
                VerificationSerialNumber: this.VerificationSerialNumber,
                InputVerificationCode: this.form.code
            }).then(data=>{
                if(data.Code == 0){
                    this.token = data.OneTimeToken.Token;
                    this.step = 2;
                } else if([2131, 2132, 2133].indexOf(data.Code) > -1){
                    this.form.codeHint = data.Message;
                }
            })
        },
        forResetPassword(){
            if(this.passwordBlur() == false || this.verifyPasswordBlur() == false){
                return ;
            }
            ResetPassword({
                MobileNumber: this.form.phone,
                TemporaryToken: this.token,
                _NewPassword: this.form.password
            }).then(data=>{
                if(data.Code == 0){
                    this.$navigation.back();
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .step1,
    .step2{
        height: 100%;
        width: 100%;
        overflow: hidden;
    }
    .container_content{
        #changePassword {
            height: calc(100% - 158px);
        }
        .title {
            height: 158px;
        }
    }
    .content{
        max-height: 632px;
        min-height: 400px;
        height: calc(100% - 252px);
        padding: 32px 40px 0;
        box-sizing: border-box;
        ul{
            li{
                width: 670px;
                margin: 0 auto;
                margin-bottom: 32px;
                .item-input{
                    width: 670px;
                    height: 112px;
                    position: relative;
                    input{
                        width: 100%;
                        height: 100%;
                        background: #F9F9F9;
                        border-radius: 20px;
                        padding: 0 32px;
                        font-size: 32px;
                        box-sizing: border-box;
                        &.error{
                            background: rgba(240,110,67,0.1);
                        }
                    }
                    .text-btn{
                        @include line-height(40px);
                        font-size: 28px;
                        font-weight: 500;
                        text-align: right;
                        position: absolute;
                        right: 32px;
                        top: 50%;
                        margin-top: -20px;
                        &.s{
                            color: #7AD21A;
                        }
                        &.c{
                            color: #FFA61C;
                        }
                    }
                }
                .hint,
                .errorHint{
                    @include line-height(40px);
                    font-size: 28px;
                    font-weight: 400;
                }
                .hint{
                    color: #8B8C8D;
                    margin-bottom: 8px;
                }
                .errorHint{
                    color: #F06E43;
                    margin-top: 8px;
                }
            }
        }
    }
    .step1 .content{
        padding-top: 80px;
    }
    .operation{
        height: 92px;
        width: 100%;
        button{
            @include btn-type-large;
            background: #F5F7F5;
            color: #1B1C1E;
        }
    }
</style>